module.exports = {
  // JCRing成员页 波兰语
  JCRing_member: {
    //首页
    index1: "Zdrowie członków",
    index2: "Grupa zdrowia",
    index3: "Członek",
    index4: "Dodaj grupę",
    index5: "Grupy dołączone",
    index6: "Ustawienia alarmu",
    index7:
      "Spraw, aby osoby dbające o Twoje zdrowie troszczyły się o Ciebie jeszcze bardziej",
    index8: "Nie dołączono do żadnej grupy",
    index9: "Centrum wiadomości",
    index10: "Zaproś dołączenie przez /telefon/ email/ kod QR/ Wechat",

    //创建群组
    addgroup1: "Nazwa grupy",
    addgroup2: "Typ grupy",
    addgroup3: "Proszę wprowadzić nazwę grupy",
    addgroup4: "Grupa rodzinna",
    addgroup5: "Grupa firmowa",
    addgroup6: "Inne grupy",
    addgroup7: "Grupa medyczna",
    addgroup8: "Grupa szkolna",
    addgroup9: "Potwierdź",
    addgroup10: "Anuluj",
    addgroup11: "Utwórz teraz",
    addgroup12: "Nazwa grupy już istnieje",

    //成员列表
    memberlist1: "Lista członków",
    memberlist2: "Jest",
    memberlist3: "Niezwykły",
    memberlist4: "Normalny",
    memberlist5: "Dodaj członka",
    memberlist6: "Rozwiąż",
    memberlist7: "Brak członków",
    memberlist8: "Ładowanie....",
    memberlist9: "Czy chcesz rozwiązać tę grupę?",
    memberlist10: "Pomyślnie rozwiązano",
    memberlist11: "Pomyślnie zapisano",
    memberlist12: "Zmień informacje o grupie",
    memberlist13: "Rozwiąż grupę",
    memberlist14: "Przegląd zdrowia",
    memberlist15: "Normalny",
    memberlist16: "Niezwykły",
    memberlist17: "Kliknij, aby zobaczyć",
    memberlist18: "Brak danych za wczoraj",
    memberlist19: "Wczoraj",
    memberlist20: "Wysłano",
    memberlist21: "Zaproszenie do grupy, oczekuje na potwierdzenie",

    //修改成员
    updatemember1: "Awatar",
    updatemember2: "Zmień",
    updatemember3: "Oryginalna Nazwa",
    updatemember4: "Zmień Nazwę",

    //健康数据,
    healthdata1: "Dane zdrowotne",
    healthdata2: "Dane zdrowotne",
    healthdata3: "Niedziela",
    healthdata4: "Poniedziałek",
    healthdata5: "Wtorek",
    healthdata6: "Środa",
    healthdata7: "Czwartek",
    healthdata8: "Piątek",
    healthdata9: "Sobota",
    healthdata10: "Tętno",
    healthdata11: "HRV",
    healthdata12: "Ciśnienie skurczowe",
    healthdata13: "Ciśnienie rozkurczowe",
    healthdata14: "Zmiana temperatury",
    healthdata15: "Saturacja tlenem we krwi",
    healthdata16: "Sen",
    healthdata17: "Stres",
    healthdata18: "Cholesterol",
    healthdata19: "Triglicerydy",
    healthdata20: "LDL cholesterol",
    healthdata21: "HDL cholesterol",
    healthdata22: "Cukier we krwi",
    healthdata23: "Przed posiłkiem",
    healthdata24: "Po posiłku",
    healthdata25: "Vo2Max",
    healthdata26: "Oddech",
    healthdata27: "Liczba kroków",
    healthdata28: "Krok",
    healthdata29: "Kalorie",
    healthdata30: "kcal",
    healthdata31: "Dystans",
    healthdata32: "KM",
    healthdata33: "tempo",
    healthdata35: "S/KM",
    healthdata36: "Min",
    healthdata37: "ładowanie danych zdrowotnych",
    healthdata38: "dane treningowe",
    healthdata39: "ostrzeżenie",
    healthdata40: "nieautoryzowany",
    healthdata41: "zmiana danych członka",
    healthdata42: "usunięcie członka",
    healthdata43: "Email:",
    healthdata44: "telefon:",
    healthdata45: "Czy chcesz usunąć tego członka?",
    healthdata46: "Nie można wyświetlić przyszłych dat",
    healthdata47: "dzisiaj",
    //邀请成员,
    addmember1: "Zaproś członka",
    addmember2: "Dodaj konto członka",
    addmember4:
      "Dzięki 'Konto członka' możesz przeglądać dane zdrowotne członków i ustawiać zakresy danych alarmowych, aby lepiej monitorować zdrowie członków",
    addmember5: "Dowiedz się więcej",
    addmember6: "Członkowie grupy zdrowia",
    addmember7: "Zaproś",
    addmember8: "Dołącz",
    addmember9: "Zaproś przez kod QR",
    addmember10: "Zaproś przez WeChat",
    addmember11: "Zaproś do grupy przez kod QR",
    addmember12: "Zaproś do grupy przez WeChat",
    addmember13: "Zaproś przez numer telefonu/e-mail",
    addmember14: "Zaproś do grupy przez numer telefonu/e-mail",
    addmember15: "Zaproś członków, aby zrozumieć ich stan zdrowia",
    addmember16: "Wyślij zaproszenie",
    addmember17: "Wysłano",
    addmember18: "Oczekiwanie na potwierdzenie",
    addmember19: "Dołączyłem",
    addmember20: "Udostępnij teraz",
    addmember21: "Zapisz obraz",
    addmember22: "Odmówiłem",
    addmember23: "Wyszedłem",
    addmember24: "Druga strona wyszła",
    addmember25: "Druga strona odmówiła",
    addmember26: "Druga strona dołączyła",
    addmember27: "Inne metody dodawania",

    // 群组二维码,
    code1: "Kod QR grupy",
    code2: "Группа управления здоровьем",
    code3:
      "Kod QR jest ważny przez 5 minut, proszę użyć go w odpowiednim czasie",
    //群组邀请,
    invide1: "Zaproszenie do grupy",
    invide2: "Zdrowie członka",
    invide3: "Zapraszamy do dołączenia do grupy...",
    invide4: "Dołącz do tej grupy",
    invide5:
      "Dla bezpieczeństwa Twoich danych, zalecamy sprawdzenie informacji o grupie przed dołączeniem",
    invide6:
      "Po dołączeniu do grupy, upoważnisz obserwujących do przeglądania Twoich danych zdrowotnych",
    //分享健康数渶设置,
    sethealthdata1: "Ustawienia danych zdrowotnych",
    sethealthdata2: "Potwierdź",
    sethealthdata3: "Proszę ustawić pseudonim",
    sethealthdata4: "Zezwól na wszystko",
    sethealthdata5: "Ustaw pseudonim",
    sethealthdata6: "Zapisz",
    sethealthdata7: "Proszę wprowadzić",
    sethealthdata8: "Proszę przesłać format obrazu",
    sethealthdata9: "Proszę ustawić pseudonim i awatar",
    sethealthdata10: "Proszę ustawić awatar",
    sethealthdata11: "Długość pseudonimu wynosi 1-8 znaków",
    // 设置数据区间,
    setscope1: "Zakres górnej i dolnej granicy tętna",
    setscope2: "Zakres górnej i dolnej granicy temperatury",
    setscope3: "Zakres górnej i dolnej granicy snu",
    setscope4: "Zakres górnej i dolnej granicy tętna płodu",
    setscope5: "Cukier we krwi przed posiłkiem",
    setscope6: "Cukier we krwi po posiłku",
    setscope7: "Zakres górnej i dolnej granicy nasycenia krwią tlenem",
    setscope8: "Kwas moczowy u mężczyzn",
    setscope9: "Kwas moczowy u kobiet",
    setscope10: "Ciśnienie skurczowe",
    setscope11: "Ciśnienie rozkurczowe",
    setscope12: "Górna granica",
    setscope13: "Dolna granica",
    setscope14: "Ustawienia alarmowe",
    setscope15: "Ustawienia zapisane",
    setscope16: "Górna granica",
    setscope17: "Dolna granica",
    setscope18: "Предупреждение",
    //下载页,
    onload1: "Kliknij",
    onload2: "Dołącz do grupy zdrowia",
    onload3: "Otwórz w przeglądarce",
    onload4: "Rozumiem",
    onload5: "Yuhong Health, ciesz się zdrowiem każdego dnia",
    onload6: "Darmowe pobieranie z App Store",
    onload7: "Darmowe pobieranie",
    onload8: "Link wygasł",
    onload9: "Kod QR wygasł",
    onload10: "Dołączono pomyślnie",

    // （消息中心）待处理,
    pending1: "Zaakceptuj",
    pending2: "Odrzuć",
    pending3: "Ponownie wyślij zaproszenie",
    pending4: "Brak dostępnych danych",
    pending5: "Zaproszenie wysłane, oczekiwanie na zgodę użytkownika",
    pending6: "Potwierdź",
    pending7: "Wyjdź",

    guide1:
      "Po wejściu do zdrowia członków, należy najpierw utworzyć odpowiedni typ grupy.",
    guide2:
      "Po utworzeniu grupy, możesz wejść do niej, aby zobaczyć przegląd zdrowia użytkownika i zaprosić nowych członków do dołączenia do grupy.",
    guide3:
      "Możesz zaprosić nowych członków do grupy za pomocą skanowania kodu, WeChat, numeru telefonu / e-mail itp. Po dołączeniu nowych członków do grupy, możesz przeglądać ich codzienne dane zdrowotne.",
    guide4:
      "Kliknij, aby zobaczyć przegląd zdrowia. Możesz przeglądać dane zdrowotne członków i oceniać, czy są one normalne czy nie.",
    guide5: "Następny krok",
    guide6: "Zakończ",
    guide7: "Przekroczenie wartości ostrzegawczej",

    invite1: "Zaproś przez numer telefonu / e-mail",
    invite2: "Proszę wprowadzić konto",
    invite3: "Proszę wprowadzić numer telefonu",
    invite4: "Proszę wprowadzić adres e-mail",
    invite5: "Wprowadź poprawny numer telefonu",
    invite6: "Wprowadź poprawny adres e-mail",
    invite7: "Dołączono do grupy",
    invite8: "Użytkownik nie istnieje",
    invite9: "Proszę wybrać kraj lub region",
    invite10: "Proszę wprowadzić słowo kluczowe",
    invite11: "Potwierdź użytkownika",
    invite12: "Zaproś ich",
    invite13: "Proszę wybrać"
  }
};



// WEBPACK FOOTER //
// ./src/lang/pl.js